
type RenderingOverlayProps = {
	isVisible: boolean;
	text?: string;
};

export const RenderingOverlay = ({
	isVisible,
	text = 'Rendering kitchen...'
}: RenderingOverlayProps): React.ReactElement | null => {
	if (!isVisible) return null;

	return (
		<div
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				backgroundColor: 'rgba(0, 0, 0, 0.7)',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 1000,
				pointerEvents: 'none'
			}}
		>
			<div
				style={{
					width: '60px',
					height: '60px',
					border: '6px solid rgba(255, 255, 255, 0.3)',
					borderTop: '6px solid white',
					borderRadius: '50%',
					animation: 'spin 1s linear infinite'
				}}
			/>
			<div
				style={{
					color: 'white',
					fontSize: '18px',
					marginTop: '20px',
					fontWeight: '500',
					animation: 'pulse 1.5s ease-in-out infinite'
				}}
			>
				{text}
			</div>
		</div>
	);
};

